var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    attrs: { visible: _vm.showModal, size: "small" },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.handleClose
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__icon--close" },
              [
                _c("CompassIconButton", {
                  attrs: { icon: "close" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default flex-column ai-center" },
              [
                _c(
                  "div",
                  { staticClass: "icon flex-column ai-center jc-center" },
                  [
                    _c("SaasIcon", {
                      attrs: { icon: "quota", width: "98", height: "75" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h2", { staticClass: "typographies-heading-h2" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [_vm._v(_vm._s(_vm.message))]
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "span",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("quotas.PopupQuotaLimit.contact_our_team"),
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onClickContact()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }